import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "material-icons btn-icon-left"
}
const _hoisted_2 = { class: "btn-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    style: _normalizeStyle(_ctx.style),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClicked($event)))
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.icon), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1 /* TEXT */)
  ], 4 /* STYLE */))
}